import React, { useCallback, useEffect, useState } from 'react'
import Box from '@mui/material/Box'

import SentimentButton from './SentimentButton'
import SentimentMenu from './SentimentMenu'
import { Option, SentimentProps } from './SentimentOptions'
import { findSelectedOption } from './SentimentHelper'
import { useAppSelector } from 'redux/Hook'

const SentimentDropdown: React.FC<SentimentProps> = ({
  options = [],
  sentimentObj,
  readonly = true,
  handleEditSentiment,
}) => {
  const {
    appConfig: { platformSentiment, sentimentToggle },
  } = useAppSelector((state) => state.textAnalysis.main)

  const [selectedOption, setOption] = useState<Option | null>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [showScore, setShowScore] = useState(true)

  useEffect(() => {
    const optionToSet = findSelectedOption(sentimentObj, options)
    setOption(optionToSet)
    setShowScore(true)
  }, [sentimentObj, options])

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (!readonly) setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleChange = useCallback(
    (option: Option) => {
      handleEditSentiment(option)
      setOption(option)
      setShowScore(false)
      handleMenuClose()
    },
    [handleEditSentiment, handleMenuClose],
  )

  if (!platformSentiment || !sentimentToggle || !selectedOption) return null

  return (
    <Box data-testid="sentiment-dropdown">
      <SentimentButton
        sentimentObj={sentimentObj}
        selectedOption={selectedOption}
        anchorEl={anchorEl}
        onClick={handleMenuOpen}
        readonly={readonly}
        isScoreVisible={showScore}
      />
      {!readonly && options.length > 0 && (
        <SentimentMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          options={options}
          selectedOption={selectedOption}
          onChange={handleChange}
        />
      )}
    </Box>
  )
}

export default SentimentDropdown
